// Class: motion.easing._Quart.QuartEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuartEaseOut = function() {
}

// Meta

QuartEaseOut.__name__ = ["motion","easing","_Quart","QuartEaseOut"];
QuartEaseOut.__isInterface__ = false;
QuartEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
QuartEaseOut.prototype = {
	calculate: function(k) {
		return -(--k * k * k * k - 1);
	},
	ease: function(t,b,c,d) {
		t = t / d - 1;
		return -c * (t * t * t * t - 1) + b;
	}
};
QuartEaseOut.prototype.__class__ = QuartEaseOut.prototype.constructor = $hxClasses["motion.easing._Quart.QuartEaseOut"] = QuartEaseOut;

// Init



// Statics




// Export

exports.default = QuartEaseOut;